import React from "react";
// import { CRow, CCol,CCard,CCardBody, CInputGroup, CButton, CFormInput } from "@coreui/react";
import { CButton, CCard, CCardBody,CFormInput, CCol, CForm, CInputGroup, CRow } from '@coreui/react'

import {
  wtApiCall,
} from "../../helpers/commons/ApiWrapper";
import { lzNotifyErrorMessageFromResult } from "../../helpers/commons/notifications";
import { currentDate } from "../../helpers/commons/moment";
import BaseListing from "../../BaseListings";
import moment from "moment";
import VisitorsReportData from "./visitors-report";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { wtGetFromLocalStorage } from "../../helpers/commons/LocalStorage";
import WidgetEmployeeSelector from "src/widgets/Selectors/WidgetEmployeeSelector";
const CURRENCY_SYMBOL = "PKR";

class VisitorsReport extends BaseListing {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      employees: [],
      filters: {
        as_on_date: currentDate(),
        from_date: "" + moment().startOf("month").format("YYYY-MM-DD") + "",
        to_date: "" + moment().format("YYYY-MM-DD") + "",
        name: "",
        employeeId: 0,
        employeeName: "",
      },
      totalCost: 0,
      orderTotal: 0,
      discountTotal: 0,
      taxTotal: 0,
      totalAmount: 0,
    };
  }

  componentDidMount() {
    this.dropdownData("employees,sales_orders", { is_customer: true });
  }
  loadData() {
    const { filters } = this.state;

    this.setState({ isLoading: true, data: [] });
    wtApiCall(
      "reports/visitors-report",
      {
        from_date: filters.from_date,
        to_date: filters.to_date,
        employeeId: filters.employeeId,
        name: filters.name,
      },
      "post",
      (result) => {
        if (result.data !== null && typeof result.data !== "undefined") {
          this.setState({
            data: result.data.data,
            isLoading: false,
          });
        }
      },
      (result) => {
        lzNotifyErrorMessageFromResult(result);
        this.setState({ isLoading: false });
      }
    );
  }

  changeValue(key, val) {
    //Make report data to empty array
    this.setState({ data: [] });

    if (key === "item_id") {
      this.setState((prevState) => {
        let filters = Object.assign({}, prevState.filters);
        filters.itemId = val.value;
        filters.name = val.label;
        return { filters };
      });
    } else if (key === "employee_id") {
      this.setState((prevState) => {
        let filters = Object.assign({}, prevState.filters);
        filters.employeeId = val.value;
        filters.employeeName = val.label;
        return { filters };
      });
    } else if (key === "sales_order_id") {
      this.setState((prevState) => {
        let filters = Object.assign({}, prevState.filters);
        filters.searchSalesOrderId = val.value;
        filters.searchSalesOrderNo = val.label;
        return { filters };
      });
    } else {
      this.setState((prevState) => {
        let filters = Object.assign({}, prevState.filters);
        filters[key] = val;
        return { filters };
      });
    }
  }

  getDuration(check_in, check_out) {
    let totalTime = "";
    if (check_out != null) {
      //convert the time in moment readable form
      const startTime = moment(check_in, "HH:mm:ss a");
      const endTime = moment(check_out, "HH:mm:ss a");

      //calculate the duration and difference between the two times
      const duration = moment.duration(endTime.diff(startTime));

      //duration in hours
      const hours = parseInt(duration.asHours());

      // duration in minutes
      const minutes = parseInt(duration.asMinutes()) % 60;

      if (hours > 0) {
        totalTime += hours + " hour and " + minutes + " min";
      } else {
        totalTime += minutes + " min";
      }
    } else {
      totalTime = "-";
    }
    return totalTime;
  }

  //Export to PDF
  generatePdfData(visitorsData) {
    var doc = new jsPDF();
    const fromDate = this.state.filters.from_date;
    const toDate = this.state.filters.to_date;
    var totalPagesExp = "{total_pages_count_string}";
    const logo = 'assets/wil-icon.png'


    //Order confirmation copy
    doc.autoTable({
      head: this.headRows(),
      body: this.bodyRows(visitorsData),
      theme: "plain",
      tableLineColor: "#3c4b64",
      tableLineWidth: 0.2,
      tableWidth: 190,
      styles: {
        lineColor: "#3c4b64",
        lineWidth: 0.2,
        font: "helvetica",
      },
      headStyles: {
        fillColor: "#fff",
        textColor: [60, 75, 100],
        setFontSize: 8,
        font: "helvetica",
      },
      didParseCell: function (data) {
        if (data.row.section === "body") {
          data.cell.styles.fontSize = 8;
          data.cell.styles.textColor = "#3c4b64";
          data.cell.styles.font = "helvetica";
          data.cell.styles.halign = "center";
        }
      },
      margin: { top: 40, bottom: 20, left: 10, right: 10 },
      didDrawPage: function (data) {
        //get page no
        let pageNo = doc.internal.getNumberOfPages();

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        doc.line(39, 7, 39, 26)
        doc.setFontSize(11)
        doc.setFont("Helvetica", "bold");
        doc.text('WAH', 40, 10, { align: 'left' })
        // doc.setFont('Helvetica')
        doc.text('INDUSTRIES', 40, 15)
        doc.text('LIMITED', 40, 20)
        doc.setFontSize(9)
        doc.text('www.wahindustries.com', 40, 25)
        // Header
        doc.setFontSize(10);
        doc.setTextColor("#3c4b64");
        doc.setFont("Helvetica", "bold");
        //Header middle branch logo
        if (logo) {
          doc.addImage(logo, "PNG", 14, 4, 25, 25);
          doc.setFontSize(14);
          if (fromDate === toDate) {
            doc.text(
              "Visitors List Dated " + moment(fromDate).format('MMMM DD,YYYY'),
              pageWidth - 145,
              38
            );
          }
          else {

                        doc.setFontSize(14)
            doc.text(
              "Visitors List From " + moment(fromDate).format('MMMM DD,YYYY') + " to " + moment(toDate).format('MMMM DD,YYYY'),
              pageWidth - 120,
              10
            );

          }
        }

        //Add header separator
        // doc.line(14, 42, 196, 42);

        //Page No
        var str = "Page " + pageNo;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str = str + " of " + totalPagesExp;
        }

        doc.setTextColor("black");
        doc.text(str, 10, pageHeight - 4);
      },
    });

    doc.setTextColor("#3c4b64");
    doc.setFontSize(9);
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }
    //Save Pdf
    doc.save("Visitor List.pdf");
  }

  headRows() {
    return [
      [
        {
          datakey: "name",
          content: "Name",
          styles: { halign: "center", valign: "middle", cellWidth: 28 },
        },
        {
          datakey: "firm",
          content: "Firm",
          styles: { halign: "center", valign: "middle", cellWidth: 25 },
        },
        {
          datakey: "cnic",
          content: "CNIC",
          styles: { halign: "center", valign: "middle", cellWidth: 28 },
        },
        {
          datakey: "employee_name",
          content: "Employee Visited",
          styles: { halign: "center", valign: "middle", cellWidth: 24 },
        },
        {
          datakey: "designation",
          content: "Designation",
          styles: { halign: "center", valign: "middle", cellWidth: 25 },
        },
        {
          datakey: "check_in",
          content: "Check IN",
          styles: { halign: "center", valign: "middle", cellWidth: 20 },
        },
        {
          datakey: "check_out",
          content: "Check OUT",
          styles: { halign: "center", valign: "middle", cellWidth: 20 },
        },
        {
          datakey: "duration",
          content: "Duration",
          styles: { halign: "center", valign: "middle", cellWidth: 20 },
        },
      ],
    ];
  }

  bodyRows(data) {
    var body = [];
    for (var i = 0; i < data.length; i++) {
      body.push([
        data[i].name,
        data[i].firm.name,
        data[i].cnic,
        data[i].employee.name,
        data[i].employee.designation.name,
        data[i].check_in,
        data[i].check_out,
        this.getDuration(data[i].check_in, data[i].check_out),
      ]);
    }
    return body;
  }

  render() {
    const { isLoading, data, filters, employees } = this.state;
    const Base = new BaseListing()
    return (
      <div style={{ padding: '2%' }}>
      <center>
      <h3>Visitors Report as on {filters.as_on_date}</h3>
      </center>


      <CRow style={{ width: '100%' }}>
      <CCol md={12}>
      <CCard className="card-dark">
      <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
      <br />
        <CForm>
          <CRow>
            <CCol md={1}>
                <CInputGroup>
                <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
               </CInputGroup>
            </CCol>
            <CCol md={2}>
            <div className="form-group">
                <label>From: *</label>
                <CFormInput
                  id="from_date"
                  type="date"
                  value={filters.from_date}
                  onChange={(ev) =>
                    this.changeValue("from_date", ev.target.value)
                  }
                />
             </div>
            </CCol>
            <CCol md="2">
            <div className="form-group">
              <label>To:*</label>
                <CFormInput
                  id="to_date"
                  type="date"
                  min={filters.from_date}
                  value={filters.to_date}
                  onChange={(ev) =>
                    this.changeValue("to_date", ev.target.value)
                  }
                />
             </div>
            </CCol>
            <CCol md="2">
              <div>
                <label>Visitor Name</label>
                <CFormInput
                  id="name"
                  type="text"
                  value={filters.name}
                  placeholder="Enter Visitor Name"
                  onChange={(ev) => this.changeValue("name", ev.target.value)}
                />
              </div>
            </CCol>
            <CCol md="3">
              <div>
                <label >Employee:</label>
                <WidgetEmployeeSelector
                  value={filters.employeeId}
                  displayValue={filters.employeeName}
                  employees={employees}
                  onChange={(values) => this.changeValue("employee_id", values)}
                  reloadDropdownData={() => this.dropdownData("employees")}
                  // size="md"
                />
              </div>
            </CCol>
            {/* {this.rights.hasRights("reports.visitors_report.list") && ( */}
            <CCol md="2">

                <CButton
                  color="primary"
                  onClick={() => this.loadData()}
                  style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}

                  // className="lz-fluid"
                >
                  Search
                </CButton>
                {Base.hasRights('Print Visitor Report') && (
                <CButton
                  color="danger"
                  onClick={() => this.generatePdfData(data)}
                  style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}

                  className="text-light"
                >
                  PDF
                </CButton>
                )}
            </CCol>
            {/* // )} */}
            {/* {this.rights.hasRights("reports.visitors_report.print") && */}
            {/* data.length > 0 && ( */}

            {/* )} */}
            </CRow>
            </CForm>
            </CCardBody>
          </ CCard>
        </CCol>
          </CRow>

        <br />
        <VisitorsReportData
          data={data}
          isLoading={isLoading}
          currencySymbol={CURRENCY_SYMBOL}
          onUpdate={(updatedData) => this.setState({ data: updatedData })}
        />
      </div>
    );
  }
}

export default VisitorsReport;
